import React from 'react';
import cn from 'classnames';
import './OfficeClockSlider.scss';

import { slotToLabel } from '../../helpers/office_helpers';

/*
 * Draggable time slider spanning 7 AM – 9 PM.
 * Supports both point selection (single click) and range selection (click + drag).
 * The "Now" marker pulses red on today's view. Hour ticks provide visual reference.
 * All drag state is managed by the parent OfficeClock — this component is purely presentational.
 */
const OfficeClockSlider = ({
  trackRef,
  handleDown,
  handleTrackHover,
  handleTrackLeave,
  hourMarkers,
  hoverPct,
  hoverSlot,
  nowPct,
  hasRange,
  startPct,
  endPct,
  dragMode,
  localStart,
  clearRange
}) => {
  return (
    <div className='clock-slider-row'>
      <div
        className='clock-track'
        ref={trackRef}
        onMouseDown={handleDown}
        onTouchStart={handleDown}
        onMouseMove={handleTrackHover}
        onMouseLeave={handleTrackLeave}
      >
        <div className='track-rail' />
        {hoverPct !== null && !dragMode && <div className='track-hover-line' style={{ left: `${hoverPct}%` }} />}
        {hoverSlot !== null && (
          <div className='track-hover-label' style={{ left: `${hoverPct}%` }}>
            {slotToLabel(hoverSlot)}
          </div>
        )}
        {hourMarkers.map(m => (
          <div key={m.hour} className={cn('track-tick', { major: m.hour % 2 === 0 })} style={{ left: `${m.pct}%` }} />
        ))}

        {nowPct !== null && (
          <div className='track-now' style={{ left: `${nowPct}%` }}>
            <div className='now-line' />
            <div className='now-label'>Now</div>
          </div>
        )}

        {hasRange ? (
          <div className='track-range' style={{ left: `${startPct}%`, width: `${endPct - startPct}%` }}>
            <div className='range-handle left' />
            <div className='range-handle right' />
            <button
              className='range-clear'
              onClick={e => {
                e.stopPropagation();
                clearRange();
              }}
              onMouseDown={e => e.stopPropagation()}
            >
              &times;
            </button>
          </div>
        ) : (
          <div className={cn('track-thumb', { dragging: !!dragMode })} style={{ left: `${startPct}%` }}>
            <div className='thumb-dot' />
            {dragMode && <div className='thumb-tooltip'>{slotToLabel(localStart)}</div>}
          </div>
        )}
      </div>
      <div className='clock-hour-strip'>
        {hourMarkers
          .filter((_, i) => i % 2 === 0)
          .map(m => (
            <span key={m.hour} className='hour-mark' style={{ left: `${m.pct}%` }}>
              {m.full}
            </span>
          ))}
      </div>
    </div>
  );
};

export default OfficeClockSlider;
